import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/basemap/view/basemap.view.query.gql"
import type {
  BasemapViewQuery,
  BasemapViewQueryVariables,
} from "@/v2-backoffice-client/basemap/view/__types__/basemap.view.query"

type Options = QueryHookOptions<BasemapViewQuery, BasemapViewQueryVariables>

export function useBasemapViewQuery(options?: Options) {
  return useQuery<BasemapViewQuery, BasemapViewQueryVariables>(query, options)
}
